<script>
export default {
    props: {
        quotationDetail :{
            type : Object,
        }
    },
}

</script>
<template>
    <table class="table table-borderless text-center table-nowrap align-middle mb-0">
        <thead>
            <tr class="table-active">
                <th scope="col" style="width: 50px;">No</th>
                <th scope="col"><center>Device</center></th>
                <th scope="col"><center>Grade</center></th>
                <th scope="col"><center>No Of Device</center></th>
                <th scope="col"><center>Unit Price</center></th>
                <th scope="col" class="text-end"><center>Amount</center></th>
            </tr>
        </thead>
        <tbody id="products-list">
            <tr v-for="(item, index) of quotationDetail.device" :key="index">
                <td scope="row">{{ index+1 }}</td>
                <td class="text-start" style="text-align: center;">
                    <center>
                        {{ item.brand }} {{item.model}} {{ item.storage }}
                    </center>
                </td>
                <td><center>{{item.name}}</center></td>
                <td><center>{{item.total}}</center></td>
                <td class="text-end"><center>{{ quotationDetail.currency }} {{item.price.toLocaleString('en-US') }}</center></td>
                <td class="text-end"><center>{{ quotationDetail.currency }} {{item.priceing.toLocaleString('en-US') }}</center></td>
            </tr>
            <tr class="border-top border-top-dashed mt-2">
                <td colspan="2"></td>
                <td colspan="2" class="fw-medium p-0">
                        <table
                            class="table table-borderless text-start table-nowrap align-middle mb-0">
                            <tbody>
                                <tr class="border-top border-top-dashed pl-5">
                                    <th scope="row">Total Device</th>
                                    <td style="padding-right: 2.5rem;" class="text-start">{{ quotationDetail.totalDevice }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <!--end table-->
                </td>
                <td colspan="2" class="fw-medium p-0">
                    <table class="table table-borderless text-start table-nowrap align-middle mb-0">
                        <tbody>
                            <!-- <tr>
                                <td>Sub Total</td>
                                <td class="text-end">{{ quotationDetail.currency }} {{quotationDetail.totalAmount}}</td>
                            </tr>
                            <tr>
                                <td>Estimated SST (6%)</td>
                                <td class="text-end">{{ quotationDetail.currency }} {{quotationDetail.GSTValue}}</td>
                            </tr>
                            <tr>
                                <td>Discount <small class="text-muted">(VELZON15)</small></td>
                                <td class="text-end">- ${{discount}}</td>
                            </tr>
                            <tr class="border-top border-top-dashed"> -->
                            <tr class="border-top">
                                <th scope="row">Total Amount</th>
                                <td class="text-end">{{ quotationDetail.currency }} {{quotationDetail.afterGST.toLocaleString('en-US')}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!--end table-->
                </td>
            </tr>
        </tbody>
    </table>
</template>